import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './style.module.css';

export const TOAST_TYPES = {
    SUCCESS: 'success',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error'
}

const types = [
    TOAST_TYPES.SUCCESS,
    TOAST_TYPES.INFO,
    TOAST_TYPES.WARN,
    TOAST_TYPES.ERROR
];

export default ({ message, type = 'info', ...props }) => {
    toast[types.find(t => t === type) || 'info'](message,
        {
            className: styles.container,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: true, ...props
        })
}
